import React from 'react';
import './BPMControl.css';

function BPMControl({ bpm, setBpm, timeSignature, setTimeSignature, onExport, onImport, onClear }) {
  const handleFileInput = (e) => {
    onImport(e);
    e.target.value = ''; // Reset input
  };

  const timeSignatures = ['2/4', '3/4', '4/4', '6/8'];

  return (
    <div className="bpm-control">
      <div className="bpm-group">
        <label className="bpm-label">BPM</label>
        <div className="bpm-input-group">
          <button 
            className="bpm-btn"
            onClick={() => setBpm(Math.max(20, bpm - 5))}
          >
            -
          </button>
          <input
            type="number"
            className="bpm-input"
            value={bpm}
            onChange={(e) => setBpm(Math.max(20, Math.min(300, parseInt(e.target.value) || 60)))}
            min="20"
            max="300"
          />
          <button 
            className="bpm-btn"
            onClick={() => setBpm(Math.min(300, bpm + 5))}
          >
            +
          </button>
        </div>
      </div>

      <div className="time-signature-group">
        <label className="time-signature-label">拍号</label>
        <div className="time-signature-buttons">
          {timeSignatures.map(ts => (
            <button
              key={ts}
              className={`time-sig-btn ${timeSignature === ts ? 'active' : ''}`}
              onClick={() => setTimeSignature(ts)}
            >
              {ts}
            </button>
          ))}
        </div>
      </div>

      <div className="control-buttons">
        <button className="control-btn save-btn" onClick={onExport}>
          💾 保存导出
        </button>
        <label className="control-btn import-btn">
          📁 导入文件
          <input 
            type="file" 
            accept=".json"
            onChange={handleFileInput}
            style={{ display: 'none' }}
          />
        </label>
        <button className="control-btn clear-btn" onClick={onClear}>
          🗑️ 清空
        </button>
      </div>
    </div>
  );
}

export default BPMControl;

